var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68957 7.46349C5.09976 4.16703 8.46884 2.07837 12.0002 2.07837C15.5316 2.07837 18.9006 4.16703 20.3108 7.46349C21.6215 10.5275 20.9136 13.141 19.4361 15.3789C18.2106 17.2351 16.4169 18.8878 14.8037 20.3742C14.5172 20.6382 14.2363 20.897 13.9654 21.1506C13.4347 21.6475 12.7297 21.9218 12.0002 21.9218C11.2707 21.9218 10.5657 21.6475 10.035 21.1507L10.0335 21.1492C9.74686 20.8792 9.44889 20.6037 9.14462 20.3222C7.54877 18.8464 5.77972 17.2105 4.5669 15.3776C3.08764 13.1421 2.37717 10.5313 3.68957 7.46349Z",
    fill: "#FF4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30698 11.0771C8.30698 9.03813 9.95985 7.38525 11.9988 7.38525C14.0377 7.38525 15.6906 9.03813 15.6906 11.0771C15.6906 13.1159 14.0377 14.7689 11.9988 14.7689C9.95985 14.7689 8.30698 13.1159 8.30698 11.0771Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.963dbfcd784448cfcb975dda7e16f289.svg";
export { ForwardRef as ReactComponent };